import { useEffect, useRef, useState } from "react";
import { Textfit } from "react-textfit";

function VariableTextCell({
  minFontSize,
  maxFontSize,
  divID,
  divClasses,
  text,
  isBold,
  isWide,
  beep
}) {
  const thisRef = useRef();
  const textFitRef = useRef();
  const [thisFontStyle, setThisFontStyle] = useState({});
  const [thisDivClasses, setThisDivClasses] = useState();
  const [minFontWidth, setMinFontWidth] = useState(100),
    [maxFontWidth, setMaxFontWidth] = useState(150); //50-200
  const [minFontWeight, setMinFontWeight] = useState(300),
    [maxFontWeight, setMaxFontWeight] = useState(900); //100-900

  const updateFontVariables = (
    containerWidth,
    containerHeight,
    windowWidth,
    windowHeight
  ) => {
    //used to decide width
    const containerAspectRatio = containerWidth / containerHeight;

    const mapValues = (value, min1, max1, min2, max2) => {
      let toReturn = min2 + (max2 - min2) * ((value - min1) / (max1 - min1));
      toReturn = Math.min(Math.max(toReturn, min2), max2);

      return toReturn;
    };

    let widthValue;
    const widthMidValue = minFontWidth + (minFontWidth + maxFontWidth) / 2;

    if (containerAspectRatio <= 1) {
      widthValue = mapValues(
        containerAspectRatio,
        0.15,
        1,
        minFontWidth,
        widthMidValue
      );
    } else {
      widthValue = mapValues(
        containerAspectRatio,
        1,
        7,
        widthMidValue,
        maxFontWidth
      );
    }

    widthValue += "%";

    //used to decide weight
    const containerArea = containerWidth * containerHeight;
    const windowArea = windowWidth * windowHeight;
    const areaRatio = containerArea / windowArea;

    const weightValue = mapValues(
      areaRatio,
      0.1,
      0.55,
      minFontWeight,
      maxFontWeight
    );

    setThisFontStyle({
      fontWeight: weightValue,
      fontStretch: widthValue,
    });
  };

  useEffect(() => {
    if(textFitRef.current){
      setTimeout(() => {
        textFitRef.current.process();
      }, 1);
    }
  },[text, beep])

  useEffect(() => {
    const defaultClasses = "variable_text_cell";
    setThisDivClasses(defaultClasses.concat(" ", divClasses ? divClasses : ""));

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        updateFontVariables(
          width,
          height,
          window.innerWidth,
          window.innerHeight
        );
      }
    });

    resizeObserver.observe(thisRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [divClasses, minFontWeight, minFontWidth]);

  useEffect(() => {
    if(!isBold) return;

    const weightGap = maxFontWeight - minFontWeight;

    const newGap = weightGap * 0.5;
    setMinFontWeight(maxFontWeight- newGap);
  }, [isBold]);

  useEffect(() => {
    if (!isWide) return;

    const widthGap = maxFontWidth - minFontWidth;

    const newGap = widthGap * 0.5;
    setMinFontWidth(maxFontWidth - newGap);
  }, [isWide]);

  return (
    <div ref={thisRef} id={divID} className={thisDivClasses}>
      <Textfit ref={textFitRef} min={minFontSize} max={maxFontSize} style={thisFontStyle}>
        {text}
      </Textfit>
    </div>
  );
}

export default VariableTextCell;
